'use strict';


export function initFontAwesome() {

}

